<app-side-nav-outer-toolbar [title]="title" [showMenu]="false">
    <router-outlet></router-outlet>
</app-side-nav-outer-toolbar>
